"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateActualPayPalFeeStructure = void 0;
/**
 * Determines the actual PayPal fee structure based on transaction recurrence.
 *
 * @param {Object} params - Parameters required for determining the fee structure.
 * @param {boolean} params.isRecurring - Indicates if the transaction is recurring.
 * @param {PayPalModelFeeStructureCountry} params.defaultFeeStructure - The base PayPal fee structure for the transaction.
 * @returns {ActualPayPalFeeStructure} The actual fee structure to be applied.
 */
const calculateActualPayPalFeeStructure = ({ isRecurring, defaultFeeStructure, }) => {
    // Relative fee based on the transaction's recurrence status
    const effectiveRelativeFee = (isRecurring && defaultFeeStructure.vaultingFee) || defaultFeeStructure.relativeFee;
    // Fixed fee based on the transaction's recurrence status.
    const effectiveFixedFee = (isRecurring && defaultFeeStructure.vaultingFixedFee) || defaultFeeStructure.fixedFee;
    return {
        relativeFee: effectiveRelativeFee,
        fixedFee: effectiveFixedFee,
    };
};
exports.calculateActualPayPalFeeStructure = calculateActualPayPalFeeStructure;
//# sourceMappingURL=calculateActualPayPalFeeStructure.js.map